// src/pages/admin/OrderPage.js
import React, { useEffect, useState } from 'react';
import Main from '../components/admin/Main';
import PageContainer from '../components/admin/PageContainer';
import Modal from '../components/admin/Modal';
import OrderForm from '../components/admin/OrderForm';
import OrderList from '../components/admin/OrderList';
import CollapseCard from '../components/admin/CollapseCard';
import { createOrder, deleteOrder, fetchOrder, updateOrder } from '../service/OrderService';

const OrderPage = () => {
  const [orderData, setOrderData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await fetchOrder()
      setOrderData(Array.isArray(res) ? res : []);
    } catch (err) {
      setError('Failed to load orders');
      console.error('Fetch orders error:', err);
    } finally {
      setLoading(false);
    }
  };

  // CREATE: Save new order
  // const createOrder = async (formData) => {
  //   try {
  //     const res = await axios.post(`${API_URL}/`, formData);
  //     if (res.data.orderId) {
  //       const newOrder = { ...formData, id: res.data.orderId };
  //       setOrderData((prev) => [...prev, newOrder]);
  //       return newOrder;
  //     }
  //   } catch (err) {
  //     throw new Error(err.response?.data?.message || 'Create failed');
  //   }
  // };

  // const updateOrder = async (id, formData) => {
  //   try {
  //     await axios.post(`${API_URL}/?id=${id}`, formData); // Uses query param
  //     setOrderData((prev) =>
  //       prev.map((item) => (item.id === id ? { ...formData, id } : item))
  //     );
  //   } catch (err) {
  //     throw new Error(err.response?.data?.message || 'Update failed');
  //   }
  // };



  useEffect(() => {
    fetchOrders();
  }, []);

  // const handleAdd = () => {
  //   setSelectedOrder(null);
  //   setShowModal(true);
  // };

  const handleEdit = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  // const handleDelete = async (id) => {
  //   if (!window.confirm('Are you sure you want to delete this order?')) return;
  //   try {
  //     await deleteOrder(id);
  //   } catch (err) {
  //     alert(err.message);
  //   }
  // };

  const handleSave = async (formData) => {
    try {
      if (selectedOrder) {
        await updateOrder(selectedOrder.id, formData);
        // alert('Order updated successfully!');
      } else {
        await createOrder(formData);
        // alert('Order created successfully!');
      }
      setShowModal(false);
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <Main><div>Loading orders...</div></Main>;
  if (error) return <Main><div className="text-danger">{error}</div></Main>;

  return (
    <Main>
      <PageContainer
        title="Order Management"
        // buttonText="Add Order"
        // onButtonClick={handleAdd}
      >
        {/* Modal */}
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => setShowModal(false)}
          headerText={selectedOrder ? 'Edit Order' : 'Add Order'}
          centered
        >
          <OrderForm
            initialData={selectedOrder}
            onSave={handleSave}
            onCancel={() => setShowModal(false)}
          />
        </Modal>

        {/* Order List */}
        <CollapseCard title="Order List">
          <OrderList
            orders={orderData}
            onEdit={handleEdit}
            // onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default OrderPage;